import MaskedInput from "react-input-mask"
import { useController } from "react-hook-form"

// Components
import { Input } from "@mobi/ds"

import { handleChange, handleBlur } from "../../handlerMethods"

// Utils
import isPhone from "@mobi/utils/validators/phone"
import mergeDeep from "@mobi/utils/object/mergeDeep"

const DEFAULT_MESSAGES = {
  required: "campo obrigatório",
  cellphone: "celular inválido",
}

const DEFAULT_RULES = {
  validate: {
    cellphone: (value) => {
      const minLength = 10
      const maxLength = 11
      const type = "cellphone"
      return isPhone(value, minLength, maxLength, type)
    },
  },
}

const Cellphone = ({
  name = "phone",
  label = "celular",
  type = "tel",
  required = true,
  autoComplete = "mobile tel-national",
  validators: { rules: propRules = {}, messages: propMessages = {} } = {},
  onChange: propOnChange = () => null,
  onBlur = () => null,
  control,
  disabled,
  ...props
}) => {
  const rules = mergeDeep(DEFAULT_RULES, propRules, { required })
  const errorMessages = mergeDeep(DEFAULT_MESSAGES, propMessages)
  const {
    field,
    fieldState: { invalid, error, isTouched, isDirty },
  } = useController({ name, control, rules })

  const isInvalid = isTouched && invalid && isDirty

  let mask = "9(9) 99999-9999"
  
  if (field?.value?.length > 0) {
    mask = "(99) 99999-9999"
  }

  function onChange(event) {
    function ensurePhoneStartsWithBracket(value) {
      if (!!value && !value.startsWith("(")) {
        return "(" + value.replace("(", "")
      }

      return value
    }

    event.currentTarget.value = ensurePhoneStartsWithBracket(event.currentTarget.value)

    handleChange(event, field, propOnChange)
  }

  return (
    <MaskedInput
      mask={field.value ? mask : null}
      maskChar={null}
      disabled={disabled}
      value={field.value}
      ref={field.ref}
      onChange={onChange}
      onBlur={(event) => handleBlur(event, field, onBlur)}
      alwaysShowMask={false}
      maskPlaceholder={null}
    >
      <Input.Default
        name={field.name}
        label={label}
        type={type}
        isValid={!isInvalid}
        errorMessage={errorMessages[error?.type]}
        aria-required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        {...props}
      />
    </MaskedInput >
  )
}

export default Cellphone
